export default __webpack_public_path__ + "static/media/mushrooms.80e597bf.png";